// Store user's answers to questions
var userAnswers = [
  {
    // Question 0
    question: 'Is this for an On-Premises or Cloud Environment?',
    answer: ''
  },
  {
    // Question 1
    question: 'Is your On-Premises environment either load balanced or failover?',
    answer: ''
  },
  {
    // Question 2
    question: 'Is your Cloud environment either load balanced or failover?',
    answer: ''
  },
  {
    // Question 3
    question: 'What Version Year of Windows Server are you looking for?',
    answer: ''
  },
  {
    // Question 4
    question: 'Enter your host specs:',
    objectArr: []
  },
  {
    // Question 5
    question: 'Enter your VM specs:',
    objectArr: []
  },
  {
    // Question 6
    question: 'Do all your hosts have the same amount of cores?',
    answer: ''
  },
  {
    // Question 7
    question: 'How many cores per host?',
    answerArr: []
  },
  {
    // Question 8
    question: 'How many unique hosts do you have?',
    answer: ''
  },
  {
    // Question 9
    question: 'Enter the amount of cores for each unique host:',
    answerArr: []
  },
  {
    // Question 10
    question: 'How many VMs do you need total?',
    answerArr: []
  },
  {
    // Question 11
    question: 'What Hypervisor are you using?',
    answerArr: []
  },
  {
    // Question 12
    question: 'Enter your VM(s) specs:',
    objectArr: []
  },
  {
    // Question 13
    question: 'How many cores are allocated per VM?',
    answerArr: []
  },
  {
    // Question 14
    question: 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
    answer: ''
  },
  {
    // Question 15
    question: 'Is your Cloud environment set up with an Active Directory or a Workgroup?',
    answer: ''
  },
  {
    // Question 16
    question: 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)',
    objectArr: []
  },
  {
    // Question 17
    question: 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
    objectArr: []
  },
  {
    // Question 18
    question: 'How many authenticating devices in your workgroup? (Only device CAL applicable in workgroup mode - Min. 1 required)',
    answer: ''
  },
  {
    // Question 19
    question: 'Of your authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
    answer: ''
  }
]
  
// Store all calculator questions
var questionTree = [
  {
    question: 'Is this for an On-Premises or Cloud Environment?',
    answers: [
      'On-Premises',
      'Cloud'
    ],
    followUpQuestions: {
      'On-Premises': 'Is your On-Premises environment either load balanced or failover?',
      'Cloud': 'Is your Cloud environment either load balanced or failover?'
    },
    percentComplete: '0%'
  },
  {
    question: 'Is your On-Premises environment either load balanced or failover?',
    answers: [
      'No',
      'Yes'
    ],
    followUpQuestions: {
      'Yes': 'What Version Year of Windows Server are you looking for?',
      'No': 'What Version Year of Windows Server are you looking for?'
    },
    percentComplete: '12%'
  },
  {
    question: 'Is your Cloud environment either load balanced or failover?',
    answers: [
      'No',
      'Yes'
    ],
    followUpQuestions: {
      'Yes': 'Enter your VM(s) specs:',
      'No': 'Enter your VM(s) specs:'
    },
    percentComplete: '20%'
  },
  {
    question: 'What Version Year of Windows Server are you looking for?',
    answers: [
      '2025',
      '2022',
      '2019',
      '2016',
      'Not Sure'
    ],
    followUpQuestions: {
      '2025': 'Enter your host specs:',
      '2022': 'Enter your host specs:',
      '2019': 'Enter your host specs:',
      '2016': 'Enter your host specs:',
      'Not Sure': 'Enter your host specs:'
    },
    percentComplete: '25%'
  },
  {
    question: 'Enter your host specs:',
    // inputRequirements: [
    //   'Each host must have an even amount of cores',
    //   'Each host must have 2 or more cores'
    // ],
    inputLabel: 'Host',
    answers: [
      'on-premises-table'
    ],
    followUpQuestions: {
      'on-premises-table': 'What Hypervisor are you using?'
    },
    percentComplete: '37%'
  },
  {
    question: 'Do all your hosts have the same amount of cores?',
    answers: [
      'Yes',
      'No'
    ],
    followUpQuestions: {
      'Yes': 'How many cores per host?',
      'No': 'How many unique hosts do you have?'
    },
    percentComplete: '45%'
  },
  {
    question: 'How many unique hosts do you have?',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'Enter the amount of cores for each unique host:'
    },
    percentComplete: '52%'
  },
  {
    question: 'Enter the amount of cores for each unique host:',
    dependentQuestion: 'How many unique hosts do you have?',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'How many VMs do you need total?'
    },
    percentComplete: '63%'
  },
  {
    question: 'How many VMs do you need total?',
    answers: [
      '1 to 11',
      '12 or more'
    ],
    followUpQuestions: {
      '1 to 11': 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
      '12 or more': 'What Hypervisor are you using?'
    },
    percentComplete: '69%'
  },
  {
    question: 'What Hypervisor are you using?',
    answers: [
      'Hyper-V',
      'vSphere, Virtualbox, etc.',
      'None'
    ],
    followUpQuestions: {
      'Hyper-V': 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
      'vSphere, Virtualbox, etc.': 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
      'None': 'Is your On-Premises environment set up with an Active Directory or a Workgroup?'
    },
    percentComplete: '50%'
  },
  {
    question: 'How many cores per host?',
    inputLabel: 'Host',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'How many VMs do you need total?'
    },
    percentComplete: '50%'
  },
  {
    question: 'How many VMs are required per host?',
    dependentQuestion: 'Enter your host specs:',
    inputLabel: 'Host',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'Is your On-Premises environment set up with an Active Directory or a Workgroup?'
    },
    percentComplete: '50%'
  },
  {
    question: 'Enter your VM(s) specs:',
    // inputRequirements: [
    //   'Each VM must have an even amount of cores',
    //   'Each VM must have 2 or more cores'
    // ],
    inputLabel: 'VM',
    answers: [
      'cloud-table'
    ],
    followUpQuestions: {
      'cloud-table': 'Is your Cloud environment set up with an Active Directory or a Workgroup?'
    },
    percentComplete: '40%'
  },
  {
    question: 'How many cores are allocated per VM?',
    dependentQuestion: 'Enter your VM(s) specs:',
    inputLabel: 'VM',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'Is your Cloud environment set up with an Active Directory or a Workgroup?'
    },
    percentComplete: '75%'
  },
  {
    question: 'Is your On-Premises environment set up with an Active Directory or a Workgroup?',
    answers: [
      'Active Directory',
      'Workgroup',
      'Not Sure'
    ],
    followUpQuestions: {
      'Active Directory': 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)',
      'Workgroup': 'How many authenticating devices in your workgroup? (Only device CAL applicable in workgroup mode - Min. 1 required)',
      'Not Sure': 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)'
    },
    percentComplete: '62%'
  },
  {
    question: 'Is your Cloud environment set up with an Active Directory or a Workgroup?',
    answers: [
      'Active Directory',
      'Workgroup',
      'Not Sure'
    ],
    followUpQuestions: {
      'Active Directory': 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
      'Workgroup': 'Of your authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
      'Not Sure': 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?'
    },
    percentComplete: '60%'
  },
  {
    question: 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)',
    answers: [
      'user-device-table'
    ],
    'Not Sure': 'END',
    followUpQuestions: {
      'user-device-table': 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?'
    },
    minimumInput: '1',
    percentComplete: '75%'
  },
  {
    question: 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
    answers: [
      'user-device-table-rds'
    ],
    'Not Sure': 'END',
    followUpQuestions: {
      'user-device-table-rds': 'END'
    },
    minimumInput: '5',
    emptyInputAccepted: true,
    percentComplete: '80%'
  },
  {
    question: 'How many authenticating devices in your workgroup? (Only device CAL applicable in workgroup mode - Min. 1 required)',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'Of your authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?'
    },
    minimumInput: '1',
    percentComplete: '75%'
  },
  {
    question: 'Of your authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?',
    answers: [
      'standard-input'
    ],
    followUpQuestions: {
      'standard-input': 'END'
    },
    emptyInputAccepted: true,
    percentComplete: '80%'
  },
  {
    question: 'END',
    answers: [],
    followUpQuestions: {},
    percentComplete: '100%'
  }
]
  
// Track the user's pathway to navigate backwards if needed
var previousQuestionPath = [];

// Default Calendly link
var calendlyWSLink = 'https://calendly.com/trusted-tech-team-licensing-engineer/15-min-windows-server-licensing-call';

// Store data to send to sales channel when 'Request a Quote' form submitted
var calcResults = 'WINDOWS SERVER CALC. RESULTS\r\nServer Licensing:\r\n';
  
// Display the answers or table for a question
function displayAnswers(questionObject) {
  if (userAnswers[3].answer == "'Not Sure'") {
    userAnswers[3].answer = '2025';
  }

  if (userAnswers[15].answer == "'Workgroup'" && userAnswers[19].answer == '') {
    userAnswers[19].answer = '0';
  }

  // Store the HTML for the possible answers that will be displayed for each question
  var questionInputsHTML = '';
  
  // Get all the possible answers for the current question and iterate through them all
  questionObject.answers.forEach((answer, index, arr) => {
    if(answer != undefined && answer != 'standard-input' && answer != 'on-premises-table' && answer != 'cloud-table' && answer != 'user-device-table' && answer != 'user-device-table-rds'){
      questionInputsHTML += '<button class="raise collection-button calc-button w-auto m-0" onclick="showNextWsQuestion(this.innerHTML)">' + answer + '</button>';
      if (arr.length - 1 == index) {
        questionInputsHTML = '<div class="d-flex flex-wrap" style="gap: 10px;">' + questionInputsHTML + '</div>';
      } 
    } else if (answer == 'standard-input') {
      if (questionObject.dependentQuestion){
        var dependentQuestion = userAnswers.find(function(obj) {
          return obj.question == questionObject.dependentQuestion;
        });
        for(var i = 0; i<dependentQuestion.answer; i++ ){
          questionInputsHTML += '<div><p class="mb-0 mt-1"'+ questionObject.inputLabel + ' #' + (i+1) + '</p><input id="standard-input-'+ i +'" data-toggle="collapse" data-target="#epSubNew" class="standard-input raise collection-button text-center" type="text" placeholder="Enter answer here"/></div>';
        }
        questionInputsHTML = '<div class="d-flex">' + questionInputsHTML + '</div><button class="raise collection-button calc-button btn-standard-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">CONTINUE</button>';
      } else {
        questionInputsHTML += '<div class="position-relative"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="Minimum of ' + parseInt(questionObject.minimumInput) + ' required"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
        questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center;" placeholder="Enter answer here" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>Minimum 5 required</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button" onclick="showNextWsQuestion('+"'"+answer+"'"+')"';
        questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>CONTINUE</button>';
      }
    } else if (answer == 'on-premises-table') {
      questionInputsHTML += '<table id="on-premises-table"><thead><tr><td>Physical Host</td><td># of Cores <i data-tippy-content="Number of physical cores across all CPUs in the server" class="fa-solid fa-circle-info"></i></td><td># of VMs <i data-tippy-content="Number of Virtual Machines running Windows Server" class="fa-solid fa-circle-info"></i></td><td><button class="btn btn-primary" onclick="addTableRow(' + "'host'" + ')"> Add Host </button></td></tr></thead><tbody id="on-premises-table-body"><tr class="on-premises-table-row" style="border-bottom: 1px solid darkgrey;"><td>#1</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="Each host requires an even number of cores greater than 1" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of Cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td>';
      questionInputsHTML += '<td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of VMs" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td><td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="Duplicate row" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="Delete row" onclick="deleteTableRow(this,' + "'host'" + ')"></i></td></tr></tbody></table>';
      questionInputsHTML += '<ul style="margin: 0 auto; text-align: left; list-style: none;"><li style="color: red; display: none;" id="on-premises-table_host-error"><p><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>Each host requires an even number of cores greater than 1</p></li><li style="color: red; display: none;" id="on-premises-table_vm-error"><p><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i># of VMs per host must be 0 or higher</p></li></ul>' + '<button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">CONTINUE</button>';
    } else if (answer == 'cloud-table') {
      questionInputsHTML += '<table id="cloud-table"><thead><tr><td>VM <i data-tippy-content="Number of Virtual Machines running Windows Server" class="fa-solid fa-circle-info"></i> </td><td># of Cores <i data-tippy-content="Number of physical cores across all CPUs in the server" class="fa-solid fa-circle-info"></i></td><td><button class="btn btn-primary" onclick="addTableRow(' + "'vm'" + ')"> Add Row </button></td></tr></thead><tbody id="cloud-table-body"><tr class="cloud-table-row" style="border-bottom: 1px solid darkgrey;"><td>#1</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="Each VM requires an even number of cores greater than 1" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of Cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td>';
      questionInputsHTML += '<td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="Duplicate row" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="Delete row" onclick="deleteTableRow(this,' + "'vm'" + ')"></i></td></tr></tbody></table><p id="cloud-table_core-error" style="color: red; display: none;"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>Each VM requires an even number of cores greater than 1</p><button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">CONTINUE</button>';
    } else if (answer == 'user-device-table') {
      questionInputsHTML += '<table id="user-device-table"><thead><tr><td>Type</td><td># of Users/Devices</td><td></td></tr></thead><tbody id="user-device-table-body"><tr class="user-device-table-row" style="border-bottom: 1px solid darkgrey;"><td>Users</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td></tr><tr class="user-device-table-row" style="border-bottom: 1px solid darkgrey;"><td>Devices</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td></tr>';
      questionInputsHTML += '<div class="d-flex flex-row order-2"><button class="raise collection-button calc-button btn-table-submit order-2" onclick="showNextWsQuestion('+"'"+answer+"'"+')">CONTINUE</button><button id="standard-0" class="raise collection-button calc-button btn-table-submit order-2" onclick="showNextWsQuestion('+"'"+answer+"'"+')">NOT SURE</button></div>';
    } else if (answer == 'user-device-table-rds') {
      questionInputsHTML += '<table id="user-device-table-rds"><thead><tr><td>Type</td><td># of Users/Devices</td><td></td></tr></thead><tbody id="user-device-table-rds-body"><tr class="user-device-table-rds-row" style="border-bottom: 1px solid darkgrey;"><td>Users</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td></tr><tr class="user-device-table-rds-row" style="border-bottom: 1px solid darkgrey;"><td>Devices</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td></tr>';
      questionInputsHTML += '<div class="d-flex flex-row order-2"><button class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">CONTINUE</button><button id="rds-0" class="raise collection-button calc-button btn-table-submit" onclick="showNextWsQuestion('+"'"+answer+"'"+')">NOT SURE</button></div>';
    }
  });

  // Display input requirements for the current question if applicable 
  if (questionObject.inputRequirements) {
    var inputRequirementsHTML = '<ul class="text-start">';
    questionObject.inputRequirements.forEach((item) => {
      inputRequirementsHTML += '<li>' + item + '</li>';
    });
    inputRequirementsHTML += '</ul>';
    $('input-requirements').show();
    document.getElementById('input-requirements').innerHTML = inputRequirementsHTML;
  } else {
    $('input-requirements').hide();
    document.getElementById('input-requirements').innerHTML = '';
  }

  // Display everything
  document.getElementById('ws-question-answers').innerHTML = questionInputsHTML;
  document.querySelector('.progress-bar').style = "width: " + questionObject.percentComplete + "; background-color: var(--border-color);";
  document.querySelector('#percent-complete').innerHTML = questionObject.percentComplete + " COMPLETE";
}

// Toggle the view of 'Your Answers'
function toggleYourAnswers(toggle) {
  if (toggle == 'show') {
    $('#your-answers').height('min-content');
    $('#your-answers-cover').hide();
  } else if (toggle == 'hide') {
    $('#your-answers').height('225px');
    $('#your-answers-cover').show();
  }
}

// Show the previous question when user navigates backwards
function showPreviousWsQuestion() {

  // Find the previous question and display it
  let currentQuestionObject = questionTree.find(function(obj) {
    return obj.question == previousQuestionPath[previousQuestionPath.length - 1];
  });
  document.getElementById('ws-question-text').innerHTML = currentQuestionObject.question;
  
  // Find the previous question in userAnswers and set to empty
  userAnswers.find(function(obj) {
    if(obj.question == currentQuestionObject.question){
      if(obj.answer){
        obj.answer = '';
      } else if (obj.answerArr){
        obj.answerArr = [];
      } else if (obj.objectArr){
        obj.objectArr = [];
      }
    }
  });

  displayAnswers(currentQuestionObject);
  previousQuestionPath.pop();

  // If first question then hide 'previous' button
  if (previousQuestionPath.length > 0){
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }

  setTooltips();
}

// Calculate the server licensing for on-premises environments to be displayed on the results page
function calculateHostLicense(host) {
  let hostResults = {
    name: '',
    cores: '',
    vms: '',
    license: '',
    licensePerHost: '',
    totalCores: '',
    user: '',
    device: ''
  };
  hostResults.name = host.name;
  hostResults.cores = host.cores;
  hostResults.vms = host.vms;
  let licenseType = '';
  let licenseCount = '';
  if (userAnswers[11].answer == "'Hyper-V'") {
    if (parseInt(host.vms) < 12) {
      licenseType = 'Standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 12) {
      licenseType = 'Datacenter';
      licenseCount = 1;
    }
  } else if (userAnswers[11].answer == "'vSphere, Virtualbox, etc.'") {
    if (parseInt(host.vms) < 29) {
      licenseType = 'Standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 29) {
      licenseType = 'Datacenter';
      licenseCount = 1;
    }
  } else if (userAnswers[11].answer == "'None'") {
    if (parseInt(host.vms) < 29) {
      licenseType = 'Standard';
      licenseCount = ((parseInt(host.vms) % 2) == 1) ? ((parseInt(host.vms)+1)/2) : (parseInt(host.vms)/2);
    } else if (parseInt(host.vms) >= 29) {
      licenseType = 'Datacenter (w/ Software Assurance)';
      licenseCount = 1;
    }
  }
  let licenseCores = '';
  if (parseInt(host.cores) <= 16) {
    licenseCores = '16';
  } else if (parseInt(host.cores) > 16) {
    if (parseInt(host.cores) % 2 == 1) {
      licenseCores = parseInt(host.cores) + 1;
    } else {
      licenseCores = host.cores;
    }
  }
  hostResults.license = 'Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' ' + licenseType + ' - ' + licenseCores + ' Core License';
  hostResults.licensePerHost = licenseCount;
  if (hostResults.licensePerHost == 0) { 
    hostResults.licensePerHost = 1 
  };
  hostResults.totalCores = ((parseInt(host.cores) < 16) ? 16 : ((parseInt(host.cores) % 2 == 1) ? (parseInt(host.cores) + 1) : parseInt(host.cores))) * hostResults.licensePerHost;
  return hostResults;
};

// Calculate the server licensing for cloud environments to be displayed on the results page
function calculateVmLicense(coreCount, numVms) {
  let vmResults = {
    license: '',
    licensePerHost: '',
    totalCores: ''
  };
  vmResults.license = 'Microsoft Windows Server ' + ((numVms > 28) ? 'Datacenter' : 'Standard') + ' - 2 Core License (w/ Software Assurance)';
  vmResults.licensePerHost = (coreCount <= 8) ? 4 : (coreCount % 2 == 0) ? (coreCount / 2) : ((coreCount + 1) / 2);
  vmResults.totalCores = ((parseInt(coreCount) < 16) ? '16' : ((parseInt(coreCount) % 2 == 1) ? (parseInt(coreCount) + 1) : parseInt(coreCount))) * vmResults.licensePerHost;
  return vmResults;
}

// Validate the inputs on submit
function validateInputs(answer) {
  let noContinue = false;
  if (answer == "on-premises-table" || answer == "cloud-table" || answer == 'user-device-table'){
    let hostError = false;
    let vmError = false;
    document.querySelectorAll('.table-input').forEach((input) => {
      if (input.placeholder == '# of Cores'){
        if (input.value <= 0 || input.value == '' || input.value % 2 != 0) {
          input.parentElement.style.border = '1px solid red';
          input.previousElementSibling.style.display = 'inline';
          hostError = true;
          noContinue = true;
        }
      } else if (input.placeholder == '# of VMs' && input.value < 0) {
      
          input.parentElement.style.border = '1px solid red';
          input.previousElementSibling.style.display = 'inline';
          vmError = true;
          noContinue = true;
      } else if (input.placeholder == '# of VMs' && input.value == ''){
          input.value = 0;
          input.setAttribute('value', 0);
          input.nextElementSibling.style.display = 'inline';
          input.parentElement.style.border = '1px solid var(--ttt-green)';
          // input.style.color = 'var(--ttt-green)';
      }
    });
    hostError ? $('#cloud-table_core-error').show() : $('#cloud-table_core-error').hide();
    hostError ? $('#on-premises-table_host-error').show() : $('#on-premises-table_host-error').hide();
    vmError ? $('#on-premises-table_vm-error').show() : $('#on-premises-table_vm-error').hide();
    if (noContinue){ return false; }
  } else if (answer == "standard-input") {
    let minInputError = false;
    let input = document.querySelector('#standard-input');
    if ((parseInt(input.min) > 0 && parseInt(input.value) < parseInt(input.min)) && (input.dataset.emptyinputaccepted == 'true' ? (parseInt(input.value) != '0' || parseInt(input.value) != '') : true )){
      input.style.border = '1px solid red';
      input.previousElementSibling.style.display = 'inline';
      minInputError = true;
      noContinue = true;
    } else if (parseInt(input.min) == 0 && input.value == '') {
      input.value = 0;
      input.setAttribute('value', 0);
    }
    minInputError ? $('#min-input-error').show() : $('#min-input-error').hide();
    if (noContinue){ return false; }
  }
}

// Store the user's submitted input
function setAnswer(answer) {
  var answeredQuestion = userAnswers.find(function(obj) {
    return obj.question == document.getElementById('ws-question-text').innerHTML;
  });
  if(answer == 'standard-input') {
    if (answeredQuestion.answerArr){
      document.querySelectorAll(".standard-input").forEach((input) => {
        answeredQuestion.answerArr.push(input.value);
      });
    } else {
      answeredQuestion.answer = document.getElementById('standard-input').value;
    }
  } else if (answer == 'cloud-table') {
    document.querySelectorAll(".cloud-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cores: ''
      };
      rowObj.name = row.children[0].innerHTML;
      rowObj.cores = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'on-premises-table') {
    document.querySelectorAll(".on-premises-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cores: '',
        vms: ''
      };
      rowObj.name = row.children[0].innerHTML;
      rowObj.cores = row.children[1].children[0].children[1].value;
      rowObj.vms = row.children[2].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'user-device-table') {
    document.querySelectorAll(".user-device-table-row").forEach((row) => {
      let rowObj = {
        name: '',
        cals: ''
      }
      rowObj.name = row.children[0].innerHTML;
      rowObj.cals = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    });
  } else if (answer == 'user-device-table-rds') {
    document.querySelectorAll(".user-device-table-rds-row").forEach((row) => {
      let rowObj = {
        name: '',
        cals: ''
      }
      rowObj.name = row.children[0].innerHTML;
      rowObj.cals = row.children[1].children[0].children[1].value;
      answeredQuestion.objectArr.push(rowObj);
    })
  }
   else {
    answeredQuestion.answer = "'" + answer + "'";
  }
}

// Show the next question based on the user's input
function showNextWsQuestion(answer) {
  if (validateInputs(answer) == false) { return; }

  (answer == "on-premises-table" || answer == "cloud-table" || answer == "user-device-table" || answer == 'user-device-table-rds') && window.scroll(0,0); 

  $('.current-question').hide();

  setAnswer(answer);
  
  var currentQuestionObject = questionTree.find(function(obj) {
    return obj.question == document.getElementById('ws-question-text').innerHTML;
  });
  
  previousQuestionPath.push(currentQuestionObject.question);
  
  if (previousQuestionPath.length > 0){
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }
  
  var nextQuestion = currentQuestionObject.followUpQuestions[answer];
  document.getElementById('ws-question-text').innerHTML = nextQuestion;
  
  var nextQuestionObject = questionTree.find(function(obj) {
    return obj.question == nextQuestion;
  });
  if(nextQuestionObject.question == 'END'){
    showResults();
  }
  
  displayAnswers(nextQuestionObject);

  $('.current-question').show();
  
  setTooltips();
}

// Validate input value on-change
function validateValue(value, e) {
  if (/^\d+$/.test(value)){
    if (value.split('')[0] == '0') {
      e.value = 0;
      e.setAttribute("value", 0);
    }
    else if ((e.placeholder == '# of Cores' || parseInt(e.min) > 0) && value == 0) {
      e.value = '';
      e.setAttribute("value", '');
      return;
    } else {
      e.setAttribute("value",value);
    }
    if (e.id == 'standard-input') {
      if (e.min){
        if ((parseInt(e.value) >= parseInt(e.min)) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)){
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          // e.style.color = "var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);
        } else {
          e.style.border = "2px solid red";
          // e.style.color = "red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (value != ''){
        e.previousElementSibling.style.display = 'none';
        e.style.border = "2px solid var(--ttt-green)";
        // e.style.color = "var(--ttt-green)";
        $('.fa-circle-exclamation').hide();
        $('.fa-circle-check').show();
        $('.collection-button').prop("disabled", false);
      } else {
        e.style.border = "2px solid var(--main-text-color)";
        // e.style.color = "var(--main-text-color)";
        $('.fa-circle-check').hide();
        $('.fa-circle-exclamation').hide(); 
        $('.collection-button').prop("disabled", true);
      }
    } else {
      if (e.placeholder == '# of Cores' && (parseInt(value) % 2 == 1 || parseInt(value) < 2 || e.value < 2)) {
          e.parentElement.style.border = "1px solid red";
          // e.style.color = "red";
          e.nextElementSibling.style.display = 'none';
          e.previousElementSibling.style.display = 'inline';
      } else {
        if (e.placeholder == '# of Cores' || e.placeholder == '# of VMs') {
          e.parentElement.style.border = "1px solid var(--ttt-green)"
          // e.style.color = "var(--ttt-green)";
          e.previousElementSibling.style.display = 'none';
          e.nextElementSibling.style.display = 'inline';
        } else {
          e.previousElementSibling.style.display = 'none';
          // e.style.color = "var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          e.parentElement.style.border = "1px solid var(--main-text-color)"; 
        }
      }
    }
  } else {
    if (e.id == 'standard-input' && value == ''){
      e.style.border = "2px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      $('.fa-circle-check').hide();
      $('.fa-circle-exclamation').hide();
      
      (parseInt(e.min) == 0) ? $('.collection-button').prop("disabled", false) : $('.collection-button').prop("disabled", true);
      return;
    }
    let inputString = convertToNumeric(value);
    e.value = inputString;
    e.setAttribute("value", inputString);
    if (e.placeholder == '# of Cores' || e.placeholder == '# of VMs') {
      e.parentElement.style.border = "1px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      e.previousElementSibling.style.display = 'none';
      e.nextElementSibling.style.display = 'none';
    }
    return;
  }
}

// Remove any non-numerical values from string
function convertToNumeric(str) {
  let numericString = str.split('');
  numericString.forEach((char, i) => {
    if (char != '0' && char != '1' && char != '2' && char != '3' && char != '4' && char != '5' && char != '6' && char != '7' && char != '8' && char != '9') {
      numericString[i] = '';
    }
  });
  return numericString.join('');
}

function displayLoadingIcon(){
  $('#loading-screen').show();
  setTimeout(() => {
    $('#loading-screen').hide();
  }, 3000);
}

// Set question and answers to be displayed on the results page
function setResponses() {
  var visibleAnswers = '';
  userAnswers.forEach((question) => {
    if(question.answer){
      if(question.answer != ''){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = question.answer.split("'")[1];
        } else {
          displayedAnswer = question.answer;
        }
        visibleAnswers += '<p style="color: var(--ttt-green);">' + displayedAnswer + '</p>';
      }
    }
    if(question.answerArr){
      var questionObj = questionTree.find(function(obj) {
        return obj.question == question.question;
      });

      if(question.answerArr.length > 0){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        question.answerArr.forEach((answer, index) => {
          visibleAnswers += '<p style="color: darkgrey;">' + questionObj.inputLabel + " #"+ (index+1) + ": <span style='color: var(--ttt-green);'>" + answer + '</span></p>';
        });
      }
    }
    if(question.objectArr){
      let questionObjArr = questionTree.find(function(obj) {
        return obj.question == question.question;
      });
      if(question.objectArr.length > 0 && question.question == 'Enter your host specs:'){
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        
        visibleAnswers += '<table class="my-3" style="background: var(--body-background);"><thead><tr style="color: var(--main-text-color); border-bottom: 1px solid var(--hr-color); font-weight: bold;"><td style="padding: 1rem;">' + questionObjArr.inputLabel + '(s)</td><td style="padding: 1rem;"># Cores</td>' + (questionObjArr.inputLabel == 'Host' ? '<td style="padding: 1rem;"># VMs</td>' : '') + '</tr></thead><tbody>';
        question.objectArr.forEach((obj) => {
          visibleAnswers += '<tr><td class="text-center" style="color: var(--main-text-color); padding: 1rem;">' + obj.name + '</td><td class="text-center" style="color: var(--ttt-green); padding: 1rem;">' + obj.cores + '</td>' + (questionObjArr.inputLabel == 'Host' ? ('<td  class="text-center" style="color: var(--ttt-green); padding: 1rem;">' + obj.vms + '</td>') : '') + '</tr>';
        });
        visibleAnswers += '</tbody></table>';
      } else if (question.objectArr.length > 0 && question.question == 'How many named users or authenticating devices are in your Active Directory? (Min. 1 required)') {
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        
        visibleAnswers += '<table class="my-3" style="background: var(--body-background);"><thead><tr style="color: var(--main-text-color); border-bottom: 1px solid var(--hr-color); font-weight: bold;"><td style="padding: 1rem;">Users</td><td style="padding: 1rem;">Devices</td>' + '</tr></thead><tbody><tr>';
        question.objectArr.forEach((obj) => {
          visibleAnswers += '<td class="text-center" style="color: var(--ttt-green); border-bottom: 1px solid var(--hr-color); padding: 1rem;">' + Number(obj.cals) + '</td>';
        });
        visibleAnswers += '</tr></tbody></table>';
      } else if (question.objectArr.length > 0 && question.question == 'Of your Named Users or Authenticating Devices, how many need the Remote Desktop Services (also known as RDP or Terminal Server)?') {
        visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + question.question + '</p>';
        
        visibleAnswers += '<table class="my-3" style="background: var(--body-background);"><thead><tr style="color: var(--main-text-color); border-bottom: 1px solid var(--hr-color); font-weight: bold;"><td style="padding: 1rem;">Users</td><td style="padding: 1rem;">Devices</td>' + '</tr></thead><tbody><tr>';
        question.objectArr.forEach((obj) => {
          visibleAnswers += '<td class="text-center" style="color: var(--ttt-green); border-bottom: 1px solid var(--hr-color); padding: 1rem;">' + Number(obj.cals) + '</td>';
        });
        visibleAnswers += '</tr></tbody></table>';
      }
    }
  });
  document.getElementById("wsc-responses").innerHTML = visibleAnswers;
}

// Set server licensing info to be displayed on the results page
function setServerLicensing() {
  var totalCores = 0;
  var hostTableResultsHTML = '';
  var vmTableResultsHTML = '';

  if (userAnswers[0].answer == "'On-Premises'") {
    userAnswers[4].objectArr.forEach((host, i) => {
      let uniqueHost = calculateHostLicense(host);
      let hostData = 'Host #' + (i+1) + ': ' + uniqueHost.cores + ' cores - ' + uniqueHost.vms + ' vms - Rec. ' + uniqueHost.license + ' - ' + uniqueHost.licensePerHost + ' Lic.\r\n';
      appendToFormData(hostData);
      hostTableResultsHTML += '<tr class="results-table-row"><td>' + uniqueHost.name + '</td><td>' + uniqueHost.cores + '</td><td>' + uniqueHost.vms + '<td class="text-start color-highlight">' + uniqueHost.license + '</td><td class="color-highlight">' + uniqueHost.licensePerHost + '</td></tr>'
      totalCores += uniqueHost.totalCores;
    });
    document.querySelector('#cores-of-licensing').innerHTML = totalCores;
    document.querySelector('#ws-table-header').innerHTML = '<th>Host</th><th># of Cores</th><th># of VMs</th><th style="text-align: left;">Recommended License</th><th># of Licenses</th>';
    document.querySelector("#ws-table-results").innerHTML = hostTableResultsHTML;
  } else if (userAnswers[0].answer == "'Cloud'") {
    let numCoreArray = [];
    userAnswers[12].objectArr.forEach((vm) => {
      numCoreArray.push(vm.cores);
    });
    if (numCoreArray.length < 29){
      for (let i = 0; i < numCoreArray.length;) {
        let uniqueVmOne = calculateVmLicense(numCoreArray[i], numCoreArray.length);
        let vmData = 'VM #' + (i+1) + ': ' + numCoreArray[i] + ' cores - Rec. ' + uniqueVmOne.license + ' - ' + uniqueVmOne.licensePerHost + ' Lic.\r\n';
        appendToFormData(vmData);
        totalCores += uniqueVmOne.totalCores;
        vmTableResultsHTML += '<tr class="results-table-row"><td>#' + (i+1) + '</td><td>' + numCoreArray[i] + '</td><td class="text-start color-highlight">' + uniqueVmOne.license + '</td><td class="color-highlight">' + uniqueVmOne.licensePerHost + '</td></tr>';
        i+=1;
      }
    } else {
      let uniqueVmOne = calculateVmLicense(numCoreArray[0], numCoreArray.length);
      let vmData = 'VM #' + (i+1) + ' - ' + numCoreArray[0] + ' cores - Rec. ' + uniqueVmOne.license + ' - ' + uniqueVmOne.licensePerHost + ' Lic.\r\n';
      appendToFormData(vmData);
      totalCores = uniqueVmOne.totalCores;
      for (let i = 1; i < numCoreArray.length+1;) {
        if (i == 1){
          vmTableResultsHTML += '<tr"><td>#' + (i) + '</td><td>' + numCoreArray[i-1] + '</td><td class="text-start color-highlight" rowspan="' + numCoreArray.length + '">' + uniqueVmOne.license + '</td><td class="color-highlight" rowspan="' + numCoreArray.length + '">' + uniqueVmOne.licensePerHost + '</td></tr>';
        } else {
          vmTableResultsHTML += '<tr"><td>#' + (i) + '</td><td>' + numCoreArray[i-1] + '</td></tr>';
        }
        i+=1;
      }
    }
    document.querySelector('#cores-of-licensing').innerHTML = totalCores;
    document.querySelector('#ws-table-header').innerHTML = '<th>VM</th><th># of Cores</th><th style="text-align: left;">Recommended License</th><th># of Licenses</th>';
    document.querySelector('#ws-table-results').innerHTML = vmTableResultsHTML;
  }
}
  
// Set CAL licensing info to be displayed on the results page
function setCalLicensing() {
  var calLicensingTableHTML = '';
  var calTableVisible = true;

  appendToFormData('\r\nCAL Licensing:\r\n');
  // Active Directory path
  if(userAnswers[14].answer == "'Active Directory'" || userAnswers[15].answer == "'Active Directory'" || userAnswers[14].answer == "'Not Sure'" || userAnswers[15].answer == "'Not Sure'") {

    let numUserCals = userAnswers[16].objectArr.length > 0 ? Number(userAnswers[16].objectArr[0].cals) : '';
    let numDeviceCals = userAnswers [16].objectArr.length > 0 ? Number(userAnswers[16].objectArr[1].cals) : '';
    let numUserRdsCals = userAnswers[17].objectArr.length > 0 ? Number(userAnswers[17].objectArr[0].cals) : '';
    let numDeviceRdsCals = userAnswers[17].objectArr.length > 0 ? Number(userAnswers[17].objectArr[1].cals) : '';

    if (userAnswers[0].answer == "'Cloud'" && (userAnswers[17].answer == '0' || userAnswers[19].answer == '0')) {
      document.querySelector('#cal-licensing-container').remove();
      calTableVisible = false;
    }
    if (numUserCals == 0 && numDeviceCals == 0 && numUserRdsCals == 0 && numDeviceRdsCals == 0) {
      document.querySelector('#cal-licensing-container').remove();
      calTableVisible = false;
    }
    document.querySelectorAll(".cal-type").forEach((calType) => {
      calType.innerHTML = 'User';
    });
    // Set standard CALs
    if (userAnswers[0].answer == "'On-Premises'" && userAnswers[16].objectArr.length > 0) {
      
      numUserCals = userAnswers[16].objectArr[0].cals == '' ? 0 : Number(userAnswers[16].objectArr[0].cals);
      numDeviceCals = userAnswers[16].objectArr[1].cals == '' ? 0 : Number(userAnswers[16].objectArr[1].cals);
      
      if (numUserCals > numDeviceCals) {
        if (numDeviceCals != 0) {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[1].name;
          calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[16].objectArr[1].cals +'</td></tr>';
          let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL) - Total: ' + Number(userAnswers[16].objectArr[1].cals) + '\r\n';
          appendToFormData(standardCalData);
        } else {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
          calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[16].objectArr[0].cals +'</td></tr>';
          let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL) - Total: ' + Number(userAnswers[16].objectArr[0].cals) + '\r\n';
          appendToFormData(standardCalData);
        }
      } else if (numUserCals < numDeviceCals) {
        if (numUserCals != 0) {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
          calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[16].objectArr[0].cals +'</td></tr>';
          let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL) - Total: ' + Number(userAnswers[16].objectArr[0].cals) + '\r\n';
          appendToFormData(standardCalData);
        } else {
          document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[1].name;
          calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[16].objectArr[1].cals +'</td></tr>';
          let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL) - Total: ' + Number(userAnswers[16].objectArr[1].cals) + '\r\n';
          appendToFormData(standardCalData);
        }
      } else if (numUserCals == numDeviceCals && (numUserCals != 0 || numDeviceCals != 0)) {
        document.querySelector('#standard-cals').innerHTML = userAnswers[16].objectArr[0].name;
        calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[16].objectArr[0].cals +'</td></tr>';
        let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 User Client Access License (CAL) - Total: ' + Number(userAnswers[16].objectArr[0].cals) + '\r\n';
        appendToFormData(standardCalData);
      }
    }
    // Set RDS CALs
    if ((userAnswers[0].answer == "'On-Premises'" || userAnswers[0].answer == "'Cloud'") && userAnswers[17].objectArr.length > 0 && (userAnswers[17].objectArr[0].cals != '' || userAnswers[17].objectArr[1].cals != '')) {
      numUserRdsCals = userAnswers[17].objectArr[0].cals == '' ? 0 : Number(userAnswers[17].objectArr[0].cals);
      numDeviceRdsCals = userAnswers[17].objectArr[1].cals == '' ? 0 : Number(userAnswers[17].objectArr[1].cals);

      if (numUserRdsCals > numDeviceRdsCals) {
        if (numDeviceRdsCals == 0) {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
          calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) +'</td></tr>';
          let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) + '\r\n';
          appendToFormData(rdsCalData);
        } else {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[1].name;
          calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) +'</td></tr>';
          let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) + '\r\n';
          appendToFormData(rdsCalData);
        }
      } else if (numUserRdsCals < numDeviceRdsCals) {
        if (numUserRdsCals == 0) {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[1].name;
          calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) +'</td></tr>';
          let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) + '\r\n';
          appendToFormData(rdsCalData);
        } else {
          document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
          calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) +'</td></tr>';
          let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) + '\r\n';
          appendToFormData(rdsCalData);
        }
      } else if (numUserRdsCals == numDeviceRdsCals && (numUserRdsCals != 0 && numDeviceRdsCals != 0)) {
        document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[17].objectArr[0].name;
        calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) +'</td></tr>';
        let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS User Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numUserRdsCals < 5 ? 5 : numUserRdsCals) + '\r\n';
        appendToFormData(rdsCalData);
      } else {
        document.querySelector('#remote-desktop-cals').closest('p').remove();
      }
    } 
  // Workgroup path
  } else if (userAnswers[14].answer == "'Workgroup'" || userAnswers[15].answer == "'Workgroup'") {
      numDeviceCals = Number(userAnswers[18].answer);
      numDeviceRdsCals = Number(userAnswers[19].answer);

      if (userAnswers[0].answer == "'Cloud'" && numDeviceRdsCals == 0) {
        document.querySelector('#cal-licensing-container').remove();
        calTableVisible = false;
      }
      document.querySelectorAll(".cal-type").forEach((calType) => {
        calType.innerHTML = 'Device';
      });
      // Set Standard CALs
      if ((userAnswers[0].answer == "'On-Premises'") && numDeviceCals > 0) {
        document.querySelector('#standard-cals').innerHTML = 'Devices';
        calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[18].answer +  '</td></tr>';
        let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL) - Total: ' + userAnswers[18].answer + '\r\n';
        appendToFormData(standardCalData);
      }
      // Set RDS CALs
      if ((userAnswers[0].answer == "'On-Premises'" || userAnswers[0].answer == "'Cloud'") && numDeviceRdsCals > 0) {
        document.querySelector('#remote-desktop-cals').innerHTML = 'Devices';
        calLicensingTableHTML += '<tr class="results-table-row"><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class=text-center color-highlight">' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) + '</td></tr>';
        let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (numDeviceRdsCals < 5 ? 5 : numDeviceRdsCals) + '\r\n';
        appendToFormData(rdsCalData);
      }
  }
  calTableVisible && (document.querySelector('#cal-table-results').innerHTML = calLicensingTableHTML);
}
  // else if (userAnswers[14].answer == "'Workgroup'" || userAnswers[15].answer == "'Workgroup'") {
    // if (userAnswers[0].answer == "'Cloud'" && userAnswers[19].answer == '0') {
    //   document.querySelector('#cal-licensing-container').remove();
    //   calTableVisible = false;
    // }
    // document.querySelectorAll(".cal-type").forEach((calType) => {
    //   calType.innerHTML = 'Device';
    //   document.querySelector('#standard-cals').innerHTML = userAnswers[18].answer;
    //   calLicensingTableHTML += '<tr><td>test</td></tr>';
    //   appendToFormData('\r\nNONE\r\n');
    // });
  // else if (userAnswers[14].answer == "'Not Sure'" || userAnswers[15].answer == "'Not Sure'") {
  //   document.querySelector('#standard-cals').closest('p').remove();
  //   document.querySelector('#remote-desktop-cals').closest('p').remove();
  //   document.querySelector('#cal-licensing-container').remove();
  //   calTableVisible = false;
  //   appendToFormData('\r\nNONE\r\n');
  // }

  // else if (userAnswers[14].answer == "'Workgroup'" || userAnswers[15].answer == "'Workgroup'") {
  //     if (userAnswers[0].answer == "'Cloud'" && userAnswers[17].objectArr.length == 0 || userAnswers[19].answer == '0') {
  //       document.querySelector('#cal-licensing-container').remove();
  //       calTableVisible = false;
  //     }
  //     document.querySelectorAll(".cal-type").forEach((calType) => {
  //       calType.innerHTML = 'Device';
  //     }); 
  //     if (userAnswers[0].answer == "'On-Premises'" && userAnswers[18].answer != '0') {
  //       document.querySelector('#standard-cals').innerHTML = userAnswers[18].answer;
  //       calLicensingTableHTML += '<tr class="results-table-row"><td>Standard</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL)</td><td class="text-center color-highlight">' + userAnswers[18].answer + '</td></tr>';
  //       let standardCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 Device Client Access License (CAL) - Total: ' + userAnswers[18].answer + '\r\n';
  //       appendToFormData(standardCalData);
  //     }
  //     if (parseInt(userAnswers[19].answer) > 0){
  //       document.querySelector('#remote-desktop-cals').innerHTML = userAnswers[19].answer < 5 ? 5 : userAnswers[19].answer;
  //       calLicensingTableHTML += '<tr><td>RDS</td><td class="color-highlight">Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + '</td><td class="text-center color-highlight">' + (userAnswers[19].answer < 5 ? 5 : userAnswers[19].answer) +'</td></tr>';
  //       let rdsCalData = 'License: Microsoft Windows Server ' + userAnswers[3].answer.replace(/[']+/g, '') + ' - 1 RDS Device Client Access License (CAL)' + (userAnswers[0].answer == "'Cloud'" ? ' (w/ Software Assurance)' : '') + ' - Total: ' + (userAnswers[19].answer < 5 ? 5 : userAnswers[19].answer) + '\r\n';
  //       appendToFormData(rdsCalData);
  //     } else {
  //       document.querySelector('#remote-desktop-cals').closest('p').remove();
  //     }
  // } 


// Toggle visibility of disclaimers
function setDisclaimers() {
  if (userAnswers[0].answer == "'Cloud'") {
    document.querySelector('#core-disclaimer').innerHTML = 'Microsoft requires a minimum of 16 cores licensed per VM';
  } else {
    document.querySelector('#core-disclaimer').innerHTML = 'Microsoft requires a minimum of 16 cores licensed per host';
  }
  if ((userAnswers[17].answer == '' || parseInt(userAnswers[17].answer) == 0) && (userAnswers[19].answer == '' || parseInt(userAnswers[19].answer) == 0) && (userAnswers[14].answer != "'Not Sure'" && userAnswers[15].answer != "'Not Sure'")) {
    document.querySelector('#rds-disclaimer').remove();
  } 
  if (parseInt(userAnswers[16].answer) >= 5 || parseInt(userAnswers[17].answer) >= 5 || parseInt(userAnswers[18].answer) >= 5 || parseInt(userAnswers[19].answer) >= 5) {
    document.querySelector('#cal-recommend-bundle').style.display = 'flex';
  }
}

// Sets the user's answers to be sent if 'Request a Quote' form submitted
function addResponsesToRFQ() {
  calcResults += '\r\nRESPONSES:\r\n';
  userAnswers.forEach((question) => {
    if(question.answer){
      if(question.answer != ''){
        calcResults += question.question + '\r\n';
        var displayedAnswer;
        if (question.answer.includes("'")){
          displayedAnswer = question.answer.split("'")[1];
        } else {
          displayedAnswer = question.answer;
        }
        calcResults += displayedAnswer + '\r\n\r\n';
      }
    }
    if(question.answerArr){
      var questionObj = questionTree.find(function(obj) {
        return obj.question == question.question;
      });
      if(question.answerArr.length > 0){
        calcResults += question.question + '\r\n';
        question.answerArr.forEach((answer, index) => {
          calcResults += (questionObj.inputLabel == "'Host'" ? "Host " : "VM") + " %23"+ (index+1) + ": " + answer + '\r\n';
        });
        calcResults += '\r\n';
      }
    }
    if(question.objectArr){
      let questionObjArr = questionTree.find(function(obj) {
        return obj.question == question.question;
      });
      if(question.objectArr.length > 0 && question.question == 'Enter your host specs:'){
        calcResults += question.question + '\r\n';
        question.objectArr.forEach((obj) => {
          calcResults += (questionObjArr.inputLabel == 'Host' ? 'Host ' : 'VM ') + obj.name + ': ' + obj.cores + ' cores ' + (questionObjArr.inputLabel == 'Host' ? (obj.vms + ' vms' ): '') + '\r\n';
        });
        calcResults += '\r\n';
      }
    }
  });
}

// Generate link to pre-filled Calendly form based on data from calculator
function setPrefilledCalendlyFormLink() {
  var calendlyParams = {
    A: '',
    B: '',
    C: '',
    D: '',
    E: '',
    F: '',
    G: '',
    H: '',
  };

  calendlyParams.A = userAnswers[0].answer == "'Cloud'" ? 1 : 2;
  calendlyParams.B = userAnswers[1].answer == "'Yes'" ? 1 : 2;
  if (userAnswers[0].answer == "'On-Premises'") {
    calendlyParams.C = userAnswers[3].answer.split("'")[1];
  } else {
    calendlyParams.C = '';
  }
  var hostAndVmInput = '';
  if (userAnswers[4].objectArr.length > 0) {
    userAnswers[4].objectArr.forEach((host, index) => {
      hostAndVmInput += "Host%20%23" + (index+1) + ":%20" + host.cores + "%20Cores%20and%20" + host.vms + "%20VMs%0A";
    });
    calendlyParams.D = hostAndVmInput;
  } else {
    userAnswers[12].objectArr.forEach((vm, index) => {
      hostAndVmInput += "VM%20%23" + (index+1) + ":%20" + vm.cores + "%20Cores%0A";
    });
    calendlyParams.D = hostAndVmInput;
  }
  if (userAnswers[0].answer == "'On-Premises'") {
    calendlyParams.E = userAnswers[11].answer.split("'")[1];
  } else {
    calendlyParams.E = '';
  }
  if (userAnswers[14].answer == "'Active Directory'" || userAnswers[15].answer == "'Active Directory'") {
    calendlyParams.F = 1;
    if (userAnswers[0].answer == "'Cloud'") {
      calendlyParams.G = '';
      calendlyParams.H = userAnswers[17].answer;
    } else {
      calendlyParams.G = userAnswers[16].answer;
      calendlyParams.H = userAnswers[17].answer;
    }
  } else if (userAnswers[14].answer == "'Workgroup'" || userAnswers[15].answer == "'Workgroup'"){
    calendlyParams.F = 2;
    if (userAnswers[0].answer == "'Cloud'") {
      calendlyParams.G = '';
      calendlyParams.H = userAnswers[19].answer;
    } else {
      calendlyParams.G = userAnswers[18].answer;
      calendlyParams.H = userAnswers[19].answer;
    }
  } else {
    calendlyParams.F = 3;
    calendlyParams.G = 0;
    calendlyParams.H = 0;
  }
  calendlyWSLink += '?a2=' + calendlyParams.A + '&a3=' + calendlyParams.B + '&a4=' + calendlyParams.C + '&a5=' + calendlyParams.D + '&a6=' + calendlyParams.E + '&a7=' + calendlyParams.F + '&a8=' + calendlyParams.G + '&a9=' + calendlyParams.H;
}

// Triggered when user reaches the last question in a pathway
function showResults() {
  $("#wsc-questions").addClass("hidden");
  window.scroll(0,0);

  displayLoadingIcon();

  setTimeout(() => {
    $('#loading-screen').hide();
    if (userAnswers[14].answer || userAnswers[15].answer){
      $("#wsc-results").removeClass("hidden");
    } else {
      $("#wsc-no-results").removeClass("hidden"); 
    }
  }, 1000);

  setResponses();
  setServerLicensing();
  setCalLicensing();
  setDisclaimers();
  addResponsesToRFQ();
  
  // pageHandle variable pulled from windows-server-calc.liquid
  $('#request-a-quote-form').html('<iframe frameborder="0" id="rfq-iframe" style="height:550px;width:99%;border:none;color-scheme:light;" src="https://forms.zohopublic.com/trustedtechteam/form/RequestforQuote1/formperma/LpJaE8Ghb9imMZgoQhQv3vmnNGII0hF_2zsqIlCSeeY?MultiLine=' + encodeURIComponent(calcResults) + '&PageHandle=' + pageHandle + '"></iframe>');

  setPrefilledCalendlyFormLink(); 
}

// Adds to the 'Request a Quote' form data.
function appendToFormData(data) {
  calcResults += data;
}

// Shows the first question in the calculator. Triggered when user clicks 'Start' on landing page.
function beginCalculator() {
  $("#main-questions-container").addClass("hidden");
  $("#wsc-questions").removeClass("hidden");
  window.scroll(0,0);
}

// Refreshes to start page. Triggered when user clicks any 'Restart Calculator' button
function restartWsCalc() {
  location.reload();
  window.scroll(0,0);
}

// Adds a new row based on the current table
function addTableRow(table) {
  if(table == 'host'){
    let hostBody = document.querySelector('#on-premises-table-body').innerHTML;
    let numHostsCurrent = document.querySelector('#on-premises-table-body').childElementCount;
    hostBody += '<tr class="on-premises-table-row" style="border-bottom: 1px solid darkgrey;"><td>#' + (numHostsCurrent+1) + '</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="Each host requires an even number of cores greater than 1" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of Cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td>';
    hostBody += '<td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="Each host requires an even number of cores greater than 1" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of VMs" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td><td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="Duplicate row" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="Delete row" onclick="deleteTableRow(this,' + "'host'" + ')"></i></td></tr>';
    document.querySelector('#on-premises-table-body').innerHTML = hostBody;
  } else if (table == 'vm') {
    let vmBody = document.querySelector('#cloud-table-body').innerHTML;
    let numVMsCurrent = document.querySelector('#cloud-table-body').childElementCount;
    vmBody += '<tr class="cloud-table-row" style="border-bottom: 1px solid darkgrey;"><td>#' + (numVMsCurrent+1) + '</td><td><div style="transition: none; position: relative; border-radius: 5px; border: solid 1px var(--main-text-color);"><i class="fa-solid fa-circle-exclamation" data-tippy-content="Each VM requires an even number of cores greater than 1" style="display: none; position: absolute; right: 10px; top: 27%; color: red;"></i><input placeholder="# of Cores" oninput="validateValue(this.value, this)" value="" class="table-input"><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 10px; top: 27%; color: var(--ttt-green);"></i></div></td><td style="display: flex; justify-content: space-evenly;"><i class="fa-solid fa-copy" data-tippy-content="Duplicate row" onclick="duplicateTableRow(this,' + "'host'" + ')"></i><i class="fa-solid fa-trash-can" data-tippy-content="Delete row" onclick="deleteTableRow(this,' + "'vm'" + ')"></i></td></tr>';
    document.querySelector('#cloud-table-body').innerHTML = vmBody;
  }
  setTooltips();
}

// Dublicates the selected row
function duplicateTableRow(e, table) {
  var currentRow = e.closest('tr');
  var clone = e.closest('tr').cloneNode(true);
  currentRow.after(clone);
  var nextRow = currentRow.nextElementSibling;
  while (nextRow) {
    nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
    nextRow = nextRow.nextElementSibling;
  }
  setTooltips();
}

// Deleted the current row
function deleteTableRow(e, table) {
  if(table == 'host'){
    let numHostsCurrent = document.querySelector('#on-premises-table-body').childElementCount;
    var currentRow = e.closest('tr');
    if (numHostsCurrent > 1) {
      var nextRow = currentRow.nextElementSibling;
      currentRow.remove();
      while (nextRow) {
        nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
        nextRow = nextRow.nextElementSibling;
      }
    }
  } else if (table == 'vm'){
    let numVMsCurrent = document.querySelector('#cloud-table-body').childElementCount;
    var currentRow = e.closest('tr');
    if (numVMsCurrent > 1) {
      var nextRow = currentRow.nextElementSibling;
      currentRow.remove();
      while (nextRow) {
        nextRow.firstChild.innerHTML = "#" + nextRow.rowIndex;
        nextRow = nextRow.nextElementSibling;
      }
    }
  }
  setTooltips();
}

function setTooltips() {
  $(function() {
    tippy('[data-tippy-content]');
  });
}

// Display Calendly pop-up form
function scheduleWSCalc() {
  Calendly.showPopupWidget(calendlyWSLink);
  return false;
}
